/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);
const serverUrl = process.env.VUE_APP_SERVER_URL;

export default new Vuex.Store({
    state: {
        customer_names: [],
      
    },

    actions: {

       
        get_customer_names({
            commit
        }) {
            axios.get(`${serverUrl}/get_customer_names`).then((response) => {
                commit("get_customer_names", response.data);
            });
        },
    },

    mutations: {
        forgot_pw(state, x) {
            state.forgot_pw = x;
        },

    },
});